import React, {
  useEffect,
  useRef,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Checkbox,
  Row,
  Col,
  Divider,
  Upload,
  notification,
  Switch,
  Button,
  Image,
  AutoComplete,
} from "antd";
import ImgCrop from "antd-img-crop";
import { cfs } from "../../../firebase/firebase";

import { PlusOutlined } from "@ant-design/icons";
import firebase from "firebase/app";
import { IItem } from "../../../models/Item";
import { IChoiceGroup } from "../../../models/choiceGroup";
import Item from "antd/lib/list/Item";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 13 },
  },
};

interface AddAndEditProductProps {
  open: boolean;
  modalType: string;
  tmpData: IItem;
  products: IItem[];
  categoryList: any[];
  currentUser: any;
  choiceGroups: IChoiceGroup[];
  handleClose: () => void;
}

export default function AddAndEditProduct({
  open,
  modalType,
  tmpData,
  products,
  categoryList,
  currentUser,
  choiceGroups,
  handleClose,
}: AddAndEditProductProps) {
  const [form] = Form.useForm();
  const [previewVisible, setPreviewVisible] = useState<boolean>(false);
  const [previewImage, setPreviewImage] = useState<string>("");
  const [previewTitle, setPreviewTitle] = useState<string>("");
  const [fileList, setFileList] = useState<any>([]);
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [editAddImage, setEditAddImage] = useState<boolean>(false);
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const [filterCat, setFilterCat] = useState<string>("");
  useEffect(() => {
    if (open && tmpData.itemName) {
      console.log("form", form, tmpData);
      form.setFieldsValue({
        itemName: tmpData.itemName,
        price: tmpData.price,
        category: tmpData.category,
        ["choices"]: tmpData.choices,
      });
    } else {
      form.resetFields();
    }
    return () => {};
  }, [open, tmpData]);

  const onOk = () => {
    form.submit();
  };

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleCancelPreview = () => {
    setPreviewVisible(false);
  };

  const handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewVisible(true);
    setPreviewImage(file.url || file.preview);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  const handleChange = ({ fileList }: any) => {
    console.log(fileList);
    setFileList(fileList);
  };

  const handleBeforeUpload = (file: any) => {
    const isImage = file.type.indexOf("image/") === 0;
    if (!isImage) {
      console.log("You can only upload image file!");
    }

    // You can remove this validation if you want
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      console.log("Image must smaller than 5MB!");
    }
    return isImage && isLt5M;
  };

  const handleCustomUpload = async ({ onError, onSuccess, file }: any) => {
    // const storage = firebase.storage();
    // const metadata = {
    //   contentType: "image/jpeg",
    // };
    // const storageRef = await storage.ref();
    // const imgFile = storageRef.child(
    //   `productsImage/${currentUser.merchantId}/${new Date().getTime()}.png`
    // );
    try {
      // const image = await imgFile.put(file, metadata);
      // const imageUrl = await image.ref.getDownloadURL();
      // console.log(fileList);
      onSuccess(null, file);
    } catch (e) {
      onError(e);
    }
  };

  const uploadImage = (file: any, newId: string) => {
    const storage = firebase.storage();
    const metadata = {
      contentType: "image/jpeg",
    };

    return new Promise((resolve, reject) => {
      storage
        .ref()
        .child(`productsImage/${currentUser.merchantId}/${newId}.png`)
        .put(file, metadata)
        .then((snap) => {
          resolve(snap.ref.getDownloadURL());
        })
        .catch((error) => {
          console.log(
            `An error occurred while uploading the file.\n\n${error}`
          );
          reject(error);
        });
    });
  };

  const onFinish = async (value: any) => {
    console.log(value);

    setConfirmLoading(true);
    Object.keys(value).map(
      (key) => value[key] === undefined && delete value[key]
    );
    let query = cfs.collection(`merchants/${currentUser.merchantId}/products`);

    if (modalType === "add") {
      let getvalue = await query.orderBy("createDate", "desc").limit(1).get();
      let newId = "P00001";
      if (getvalue.size > 0) {
        let lastId = getvalue.docs[0].data().productId;
        newId = `P` + `${Number(lastId.substring(1, 6)) + 1}`.padStart(5, "0");
      }

      if (fileList.length > 0) {
        let imageUrl: any = await uploadImage(fileList[0].originFileObj, newId);
        saveData(imageUrl, value, newId, query);
      } else {
        saveData("", value, newId, query);
      }
    } else if (modalType === "edit") {
      if (fileList.length > 0) {
        let imageUrl: any = await uploadImage(
          fileList[0].originFileObj,
          tmpData.productId
        );
        updateData(imageUrl, value, tmpData.productId, query);
      } else {
        updateData("", value, tmpData.productId, query);
      }
    }
  };

  const saveData = (imageUrl: any, value: any, newId: any, query: any) => {
    let tmpData = {
      ...value,
      productId: newId,
      createDate: firebase.firestore.Timestamp.fromDate(new Date()),
      updateDate: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    if (imageUrl) {
      tmpData = { ...tmpData, imageUrl: imageUrl };
    }
    query
      .doc(newId)
      .set(tmpData)
      .then((doc: any) => {
        setConfirmLoading(false);
        openNotificationWithIcon("success", "สำเร็จ", "เพิ่มสินค้าใหม่สำเร็จ");
        closeModal();
      })
      .catch((e: any) => {
        console.log(e);
        setConfirmLoading(false);
        openNotificationWithIcon(
          "error",
          "เกิดข้อผิดพลาด",
          "ไม่สามารถเพิ่มสินค้าใหม่ได้"
        );
        closeModal();
      });
  };

  const updateData = (imageUrl: any, value: any, id: any, query: any) => {
    console.log(imageUrl, value, id, query);
    let tmpData = {
      ...value,

      updateDate: firebase.firestore.Timestamp.fromDate(new Date()),
    };
    if (imageUrl) {
      tmpData = { ...tmpData, imageUrl: imageUrl };
    }
    query
      .doc(id)
      .update(tmpData)
      .then((doc: any) => {
        setConfirmLoading(false);
        openNotificationWithIcon("success", "สำเร็จ", "บันทึกการแก้ไขแล้ว");
        closeModal();
      })
      .catch((e: any) => {
        console.log(e);
        setConfirmLoading(false);
        openNotificationWithIcon(
          "error",
          "เกิดข้อผิดพลาด",
          "ไม่สามารถบันทึกการแก้ไขแล้ว"
        );
        closeModal();
      });
  };
  const openNotificationWithIcon = (
    type: any,
    title: string,
    description: string
  ) => {
    notification[type]({
      message: title,
      description: description,
      placement: "bottomRight",
    });
  };

  const closeModal = () => {
    setFileList([]);
    setEditAddImage(false);
    handleClose();
  };

  const onSearch = (searchText: string) => {
    let cats: any = Array.from(new Set(products.map((i: IItem) => i.category)))
      .filter((i: string) => i.includes(searchText))
      .map((i: string) => ({ value: i }));
    console.log(cats);
    setOptions(!searchText ? [] : cats);
  };
  const onSelect = (data: string) => {
    console.log("onSelect", data);
  };
  const onChange = (data: string) => {
    setFilterCat(data);
  };

  return (
    <Modal
      title="เพิ่มสินค้า"
      visible={open}
      // onOk={onOk}
      width={500}
      confirmLoading={confirmLoading}
      onCancel={() => handleClose()}
      footer={[
        <Button onClick={() => handleClose()}>ยกเลิก</Button>,
        <Button type="primary" loading={confirmLoading} onClick={onOk}>
          ตกลง
        </Button>,
      ]}
    >
      {" "}
      <Form
        form={form}
        name="addProduct"
        onFinish={onFinish}
        {...formItemLayout}
        initialValues={{
          choices: [],
        }}
      >
        <Form.Item
          name="itemName"
          label="ชื่อสินค้า"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        {/* <Form.Item
          label="ประเภท"
          name="category"
          rules={[{ message: "ระบุชื่อสินค้า", required: true }]}
        >
          <Select allowClear>
            {/* {categoryList &&
              categoryList.map((item, index) => (
                <Option value={item.value} key={index}>
                  {item.value}
                </Option>
              ))} 
            <Option value={`นมสด`}>{`นมสด`}</Option>
            <Option value={`ชา`}>{`ชา`}</Option>
            <Option value={`อิตาเลี่ยน`}>{`อิตาเลี่ยน`}</Option>
          </Select>
        </Form.Item> */}

        <Form.Item
          name="category"
          label="หมวดหมู่"
          rules={[{ required: true }]}
        >
          {/* <Input /> */}
          <AutoComplete
            options={options}
            onSelect={onSelect}
            onSearch={onSearch}
          />
        </Form.Item>

        <Form.Item
          name="price"
          label="ราคา"
          rules={[{ message: "ระบุราคา", required: true }]}
        >
          <InputNumber />
        </Form.Item>
        <Form.Item name="isSuggest" label="รายการแนะนำ" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item name="choices" label="ตัวเลือกเสริม">
          <Checkbox.Group>
            <Row>
              {choiceGroups.map((item: any, index: number) => (
                <Col span={24} key={`col-${index}`}>
                  <Checkbox value={`${item.id}`} style={{ lineHeight: "32px" }}>
                    {`${item.choiceName}`}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Form>{" "}
      <Divider />
      <Row>
        <Col sm={6} style={{ textAlign: "right" }}>
          {" "}
          <div style={{ marginRight: 8 }}>รูปภาพ :</div>
        </Col>
        <Col sm={12}>
          {" "}
          {modalType === "edit" ? (
            tmpData.imageUrl ? (
              editAddImage ? (
                <ImgCrop aspect={100 / 100}>
                  <Upload
                    accept="image/*"
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    beforeUpload={handleBeforeUpload}
                    customRequest={handleCustomUpload}
                  >
                    {fileList.length >= 1 ? null : (
                      <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>Upload</div>
                      </div>
                    )}
                  </Upload>
                </ImgCrop>
              ) : (
                <div>
                  <Image
                    width={100}
                    src={tmpData.imageUrl}
                    fallback="data:image/png;base64,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"
                  />
                  <a
                    onClick={() => {
                      setEditAddImage(true);
                    }}
                  >
                    เปลี่ยนรูป
                  </a>
                </div>
              )
            ) : (
              <ImgCrop aspect={100 / 100}>
                <Upload
                  accept="image/*"
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleChange}
                  beforeUpload={handleBeforeUpload}
                  customRequest={handleCustomUpload}
                >
                  {fileList.length >= 1 ? null : (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  )}
                </Upload>
              </ImgCrop>
            )
          ) : (
            <ImgCrop aspect={100 / 100}>
              <Upload
                accept="image/*"
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                beforeUpload={handleBeforeUpload}
                customRequest={handleCustomUpload}
              >
                {fileList.length >= 1 ? null : (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                )}
              </Upload>
            </ImgCrop>
          )}
        </Col>
      </Row>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancelPreview}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </Modal>
  );
}
